export const header = {
    logo: {
        src: "./qease-logo.png",
        alt: "logo",
        href: "/",
    },
    links: [
        {
            label: "Fitur",
            href: "#features",
        },
        {
            label: "Paket",
            href: "#pricing",
        },
        {
            label: "Testimoni",
            href: "#testimonials",
        },
        {
            label: "FAQs",
            href: "#faqs",
        },
        {
            label: "Kontak",
            href: "#contact",
        },
    ],
    buttons: [
        {
            href: "/login",
            label: "Login",
            color: "dark",
            size: "small",
        },
    ],
};
